<template>
  <v-card v-if="!isLoading" style="height: auto">
    <UsedQuotaInfo :service="`可使用容器數`" :usage="getUsedQuantity" :limit="getQuota" :is_show_percentbar="true" />

    <v-divider></v-divider>

    <v-card-title class="text_primary">
      {{ page_title }}

      <v-spacer></v-spacer>

      <v-btn class="mr-2 white--text" color="#5087e6" @click="newContainer"> 新增 </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        sort-by="created_at"
        :items-per-page="items.length"
      >
        <template #[`item.id`]="{ item }">
          <span class="row-pointer" @click="goEditPage(item)">
            {{ item.id }}
          </span>
        </template>

        <!-- <template v-slot:[`item.is_default`] = "{ item, attrs, on }">
              
              <v-checkbox
                v-bind="attrs"
                v-on="on"
                @click="updateDefault(item)"
                v-model="item.is_default"
              ></v-checkbox>
              
            </template>   -->

        <template #[`item.actions`]="{ item, attrs, on }">
          <v-menu offset-y bottom right v-bind="attrs" v-on="on">
            <template #activator="{ on }">
              <v-tooltip bottom>
                <template #activator="{ on: tooltipOn }">
                  <v-btn icon v-on="{ ...on, ...tooltipOn }">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <span>點擊查看更多</span>
              </v-tooltip>
            </template>

            <v-list style="padding: 0px" dense>
              <v-list-item @click="goEditPage(item)">
                <v-icon left> mdi-file-edit-outline </v-icon>
                <v-list-item-title>編輯</v-list-item-title>
              </v-list-item>

              <!-- 如果是預設容器就不要讓使用者把它刪掉，把刪除按鈕禁用 -->
              <v-list-item @click="deleteContainer(item)">
                <v-icon left> mdi-trash-can-outline </v-icon>
                <v-list-item-title>刪除</v-list-item-title>
              </v-list-item>

              <v-list-item @click="open_script_dialog(item)">
                <v-icon left> mdi-content-duplicate </v-icon>
                <v-list-item-title>安裝/檢查代碼</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template #[`item.is_installed`]="{ item }">
          <span v-if="item.is_installed" class="success--text"> 已安裝 </span>

          <span v-else class="warning--text"> 未安裝 </span>
        </template>
      </v-data-table>
    </v-card-text>
    <ContainerNew v-if="is_show_new_dialog" @send="addContainer" @close="closeNewDialog" />

    <LoadingOverlay :is-loading="isLoading" />

    <InstallAbTestScriptDialog
      v-if="is_open_abtest_script"
      :container-id="selected_container_id"
      :check_url="selected_container_url"
      :container_name="selected_container_name"
      @closeScriptDialog="close_script_dialog"
      @refreshContainerList="refreshContainerList"
    />

    <ContainerDialogForm
      v-if="open_container_default_dialog_setting"
      :container-default-dialog-setting="container_default_dialog_setting"
      @close="open_container_default_dialog_setting = false"
      @update="updateDefaultInContainer"
    />
  </v-card>
</template>

<script>
// 引入Vuex Helper
import { mapGetters } from 'vuex'

// import GanttChart from "@/components/Utils/GanttChart.vue"

import { apiCreateContainer, apiGetContainers } from '@/api/optimize.js'

import { apiDeleteContainer } from '@/api/optimize.js'

import { apiUpdateDefult, apiCheckLogin } from '@/api/user.js'

// 載入子組件
import InstallAbTestScriptDialog from '@/views/OptimizePage/Experiment/ChildComponent/Settings/InstallAbTestScriptDialog.vue'
import ContainerNew from './Components/ContainerNew.vue'
import LoadingOverlay from '@/components/Utils/LoadingOverlay.vue'
import UsedQuotaInfo from '@/components/Utils/UsedQuotaInfo.vue'
import ContainerDialogForm from './Components/ContainerDialogForm.vue'

export default {
  name: 'ContainerList',
  components: {
    ContainerNew,
    LoadingOverlay,
    InstallAbTestScriptDialog,
    UsedQuotaInfo,
    ContainerDialogForm,
    // GanttChart
  },
  data: function () {
    return {
      defaultItem: null,
      orgItems: [
        // {
        //   title: '管理員',
        //   icon: 'mdi-shield-crown-outline',
        // },
        // { divider: true, inset: false },
        {
          title: '容器',
          icon: 'mdi-alpha-c-box-outline',
        },
        { divider: true, inset: false },
      ],

      isLoading: false,

      // 頁面名稱
      page_title: '容器',

      // items
      items: [],

      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: '名稱', value: 'name', sortable: false },
        { text: '網站', value: 'domain', sortable: false },
        { text: '建立時間', value: 'created_at', sortable: false },
        { text: '代碼安裝狀態', value: 'is_installed', sortable: false },
        // { text: '設為登入預設容器', value: 'is_default', sortable: false },
        { text: '更多操作', value: 'actions', sortable: false },
      ],

      btn: {
        view: '檢視',
        delete: '刪除',
      },

      is_show_new_dialog: false,

      is_open_abtest_script: false,

      selected_container_id: null,

      selected_container_url: '',

      selected_container_name: '',

      container_default_dialog_setting: {
        // title: '容器預設值更新',
        // fields: [
        //   {
        //     "id": "org_name",
        //     "label": "組織名稱",
        //     "value": null,
        //     "hint": "example@example.com",
        //     "type": "text"
        //   },
        //   {
        //     "id": "principle_email",
        //     "label": "電郵",
        //     "value": null,
        //     "hint": "example@example.com",
        //     "type": "text"
        //   }
        // ],
        // submit_text: '完成',
        // submit_callback: 'update',
        // close_callback: 'close',
      },

      open_container_default_dialog_setting: false,
    }
  },
  watch: {},
  created: async function () {
    try {
      this.isLoading = true
      this.items = await this.getContainers()
      let user_data = await apiCheckLogin()
      user_data = user_data.data.data
      console.log('user_data', user_data)
      console.log('items', this.items)
      let user_info_container = []
      let enabled_status = user_data.container_user_enabled.enabled_status.find((status) => {
        return status.userAuthId.orgId === this.$route.params.org_id && status.enable
      })

      if (enabled_status) {
        user_data.container_user_enabled.container.forEach((container) => {
          user_info_container.push(container.id)
        })
      }
      console.log('enabled_status', enabled_status)
      console.log('user_info_container', user_info_container)
      if (!user_data.is_beta_user && enabled_status) {
        this.items = this.items.filter((container) => {
          return user_info_container.includes(container.id)
        })
      }

      console.log('containersss', this.items)
    } catch (e) {
      console.log(e)
      this.$root.vtoast.show({ message: e.name + ': ' + e.message, color: 'error' })
    } finally {
      this.isLoading = false
    }
  },
  mounted: function () {
    console.log('yo Container List')
  },
  methods: {
    async updateDefaultInContainer(field) {
      console.log(field)
      let { default_value } = this.loggedInfo
      let result = {}
      Object.values(field.fields).forEach((array) => {
        array.forEach((item) => {
          console.log(item)
          if (item?.id && item?.value) {
            // 确保id和value都存在
            result[item.id] = item.value
          }
        })
      })
      console.log(result)

      let params = {
        default_value: {
          ...default_value,
          containersValue: {
            ...default_value?.containersValue,
            [field.container_name]: result,
          },
        },
      }
      console.log(params)
      let updateResult = await this.updateDefaultValue(params, '更新容器預設值')
      console.log(updateResult)
      if (updateResult) {
        console.log('fsdfds')
        this.open_container_default_dialog_setting = false
      }
    },
    async updateDefault(item) {
      console.log(item)
      let { default_value } = this.loggedInfo
      let { container } = default_value

      if (container !== undefined) {
        this.items = this.items.map((field) => {
          if (field.name === item.name) {
            return { ...field, is_default: true }
          }
          return { ...field, is_default: false }
        })
      }

      let params = {
        default_value: {
          ...default_value,
          container: {
            ...default_value?.container,
            [this.selectedOrg.org_name]: item.name,
          },
        },
      }
      console.log(params)
      await this.updateDefaultValue(params, '變更預設容器')
    },
    async updateDefaultValue(params, actions_name) {
      let result = false
      await apiUpdateDefult(params)
        .then((resp) => {
          console.log(resp)
          if (resp.data.ok === 1) {
            result = true
            let {
              data: { data },
            } = resp
            this.$store.commit('login', { default_value: data })
            this.$root.vtoast.show({
              message: `${actions_name}成功!`,
              color: 'primary',
            })
            // return result
          } else {
            this.$root.vtoast.show({
              message: `${actions_name}失敗，原因:${resp.data.ok}`,
              color: 'primary',
            })
            result = false
            // return result
          }
        })
        .catch((error) => {
          this.$root.vtoast.show({
            message: `${actions_name}失敗，原因: ${error.response ? error.response : error}`,
          })
          console.log(error)
          result = false
          // return result
        })

      return result
    },
    goEditPage(item) {
      console.log('click_container', item)
      this.$router.push(`${item.id}/edit`)

      sessionStorage.setItem('selected_container', JSON.stringify(item))

      // console.log(item);
      // // console.log(this.logg);
      // let { default_value: { containersValue } } = this.loggedInfo
      // // containersValue?.[item.name]/

      // this.container_default_dialog_setting = {
      //     container_name: item.name,
      //     title: `${item.name} 預設值設定(更新)`,
      //     fields: {
      //       "marketing_tool": [
      //         {
      //           "category": "行銷小工具"
      //         },
      //         {
      //           "id": "preview_url",
      //           "label": "行銷圖卡 - 預覽連結",
      //           "value": containersValue?.[item.name]?.["preview_url"] || null,
      //           "hint": "https://www.example.com/test",
      //           "category": "行銷小工具"
      //         },
      //         {
      //           "id": "coupon_id",
      //           "label": "行銷圖卡 - 圖卡代碼",
      //           "value": containersValue?.[item.name]?.["coupon_id"] || null,
      //           "hint": "test",
      //           "category": "行銷小工具"
      //         },
      //         {
      //           "id": "card_image",
      //           "label": "行銷圖卡 - 圖片網址",
      //           "value": containersValue?.[item.name]?.["card_image"] || null,
      //           "hint": "請輸入圖片網址",
      //           "category": "行銷小工具"
      //         },
      //       ],
      //       "optimize_page": [
      //         {
      //           "category": "頁面優化"
      //         },
      //         {
      //           "id": "url",
      //           "label": "實驗 - 網址",
      //           "value": containersValue?.[item.name]?.["url"] || null,
      //           "hint": "https://www.example.com/test",
      //           "category": "頁面優化"
      //         }
      //       ]
      //     },
      //     submit_text: '完成',
      //     submit_callback: 'update',
      //     close_callback: 'close',
      // }
      // this.open_container_default_dialog_setting = true
      // this.$router.replace({
      //     path: `${this.selectedOrg.org_id}/setting/edit`,
      //     query: {
      //       current_tab: 'containers'
      //     }
      // })
    },
    open_script_dialog(item) {
      console.log('open')
      this.selected_container_id = item.id
      this.selected_container_url = item.domain
      this.selected_container_name = item.name
      console.log(this.selected_container_url)
      this.is_open_abtest_script = true
    },
    close_script_dialog() {
      console.log('close')
      this.is_open_abtest_script = false
    },
    getContainers: async function () {
      console.log(this.$route)
      let that = this
      let data = []
      data = await apiGetContainers(this.$route.params.org_id)
        .then(function (resp) {
          return resp.data.data
        })
        .catch(function (error) {
          console.log(error)
          if (error.response.status === 401) {
            that.$router.push(`/${that.$route.params.org_id}/401`)
          } else {
            that.$root.vtoast.show({
              message: '取得容器失敗，原因: ' + error.response ? error.response.data : error,
            })
          }
          return []
        })
      return data
    },
    newContainer: function () {
      this.is_show_new_dialog = true
    },
    closeNewDialog: function () {
      this.is_show_new_dialog = false
    },
    addContainer: async function (container) {
      let that = this
      console.log(this.selected_organize.org_id)
      await apiCreateContainer(container, this.selected_organize.org_id)
        .then(async function (resp) {
          let data = resp.data
          console.log(data)
          that.is_show_new_dialog = false
          that.$root.vtoast.show({
            color: 'primary',
            message: '新增成功！',
          })
          that.$router.go()
          // let items = await that.getContainers()
          that.items = await that.getContainers()
          // that.$store.commit("container_items", that.items)

          // items跑迴圈塞回去vuex appindex appsidebar寫watch監聽要及時更新
          // this.items.forEach(item => {
          //   if (item['domain'] === container.domain) {
          //     that.$store.commit("selected_container", item)
          //   }
          // })

          // let create_item =  items.filter(item => {
          //   return item.domain === container.domain
          // })

          // items ? that.$store.commit("selected_container", items[items.length-1]) : items
          // const router = that.$router
          // that.$store.dispatch('updateContainerId', { newContainerId: that.selectedContainer.id, route: that.$route.path, router: router })
          // that.$router.push('/:container_id/container/experiments')
        })
        .catch(function (error) {
          console.log(error)
          let message = ''
          if (error.includes('you can only create')) {
            message = '新增容器失敗，原因: 已達容器數上限，請加購或刪除已經存在的容器。'
          } else if (error.includes('401')) {
            message = '新增容器失敗，原因: 沒有權限新增容器。'
          } else {
            message = error
          }
          that.$root.vtoast.show({
            message: message,
          })
        })
    },
    async deleteContainer(item) {
      console.log(item)
      let confirm_dialog = confirm(`確定要刪除 ${item.name} 這個容器嗎？`)

      if (confirm_dialog) {
        console.log('刪除')
        console.log(item)
        await apiDeleteContainer(item.id, item.org_id)
          .then(async (resp) => {
            console.log(resp)
            this.items = await this.getContainers()
            // this.$store.commit("container_items", this.items)
            // this.$router.go()
          })
          .catch((error) => {
            console.log(error)
            if (error.response.status === 401) {
              this.$root.vtoast.show({
                message: `您沒有權限刪除容器！`,
              })
            } else {
              this.$root.vtoast.show({
                message: '刪除容器失敗，原因: ' + error.response ? error.response.data : error,
              })
            }
          })
      } else {
        console.log('不刪除')
      }
    },
    async refreshContainerList() {
      console.log('refresh')
      this.items = await this.getContainers()
    },
  },
  computed: {
    selected_organize() {
      return this.$store.getters.selectedOrg
    },
    ...mapGetters([
      'memberQuota',
      'loggedInfo',
      'organize_container_mapper',
      'tab',
      'selectedOrg',
      'selectedContainer',
    ]),
    getQuota() {
      const result = this.memberQuota[this.$route.params.org_id].quotaVo.find((item) =>
        item['function'].includes('Container')
      )
      return result['limit']
    },
    getUsedQuantity() {
      return this.items.length
    },
  },
}
</script>
<style scoped>
.org_content {
  max-width: 414px;
}

h4 {
  color: #5b5b5b;
}

.btn-danger {
  background: #e3262e;
  background-image: linear-gradient(180deg, #e3262e, #ab171e);
  color: #fff;
  border: 1px solid #ab171e;
  text-decoration: none;
  min-width: 40px;
  box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}
.row-pointer {
  cursor: pointer;
  color: #1a73e8;
}
.row-pointer:hover {
  color: #174ea6;
  text-decoration: underline;
}
</style>
